const EMAIL_LINK = (
  <a href="mailto:lcihotline@inmarket.com">lcihotline@inmarket.com</a>
);

const NOT_AVAILABLE_STATUS = 420;

const MESSAGES = {
  403: {
    title: 'Forbidden',
    message: (
      <>
        If you have any questions regarding access to this campaign, please
        contact {EMAIL_LINK}.
      </>
    ),
  },
  404: {
    title: 'Not Found',
    message: (
      <>
        It may not exist, or the campaign ID may be incorrect. If you have any
        questions, please contact {EMAIL_LINK}.
      </>
    ),
  },
  [NOT_AVAILABLE_STATUS]: {
    title: 'Not Yet Available',
    message: (
      <>
        If you have any questions regarding access to this campaign, please
        contact {EMAIL_LINK}.
      </>
    ),
  },
  default: {
    title: 'Oops...',
    message: (
      <>
        An internal error has occurred. Our engineering team has been notified.
        If you have any immediate needs, please reach out to {EMAIL_LINK}.
      </>
    ),
  },
};

const getMessageFromStatusCode = (statusCode: number | null) => {
  const defaultMessage = MESSAGES.default;
  if (!statusCode) return defaultMessage;

  const statusAsString = statusCode.toString();

  const message =
    statusAsString in MESSAGES
      ? MESSAGES[statusAsString as keyof typeof MESSAGES]
      : defaultMessage;

  return message;
};

type ErrorMessageProps = { statusCode: number | null };

const ErrorMessage = (props: ErrorMessageProps) => {
  const message = getMessageFromStatusCode(props.statusCode);

  return (
    <div className="container-fluid error-message">
      <h2>{message.title}</h2>
      <p>{message.message}</p>
      <p>
        Try refreshing the page, or click <a href="/">here</a> to return to the
        homepage.
      </p>
    </div>
  );
};

export default ErrorMessage;
